(() => {
  if (window.tkPostHogInstalled || window.Shopify?.designMode) return;
  if (!['talithakoum.com', 'www.talithakoum.com'].includes(location.hostname)) return;
  if (/\/(account|checkouts?|orders)(\/|$)/.test(location.pathname)) return;
  window.tkPostHogInstalled = true;
  const token = 'phc_vmFzVPMMtwJGZfQWeGCEEZdcFfYnUr7r94H4WN3QGGuV';
  const idCookie = 'tk_ph_distinct_id';
  const sessionCookie = 'tk_ph_session_id';
  let loading = false;
  let ready = false;
  let active = false;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
  const readCookie = (name) => document.cookie.split('; ').find((part) => part.startsWith(name + '='))?.substring(name.length + 1);
  function cookie(name, value, age = 31536000) {
    document.cookie = `${name}=${value}; Path=/; Max-Age=${age}; SameSite=Lax; Secure`;
  }
  function safeUrl(value) {
    try {
      const url = new URL(value, location.origin);
      if (/\/(account|checkouts?|orders)(\/|$)/.test(url.pathname)) return url.origin + '/[private]';
      return url.origin + url.pathname;
    } catch { return ''; }
  }
  function scrub(event) {
    if (!allowed()) return null;
    const props = event.properties = { ...event.properties, ...pageProperties() };
    if (props.$session_id) syncSession(props.$session_id);
    for (const key of ['$current_url', '$referrer', '$initial_current_url', '$initial_referrer']) {
      if (props[key]) props[key] = safeUrl(props[key]);
    }
    for (const group of ['$set', '$set_once']) {
      for (const key of Object.keys(props[group] || {})) {
        if (/url|referrer/.test(key)) props[group][key] = safeUrl(props[group][key]);
      }
    }
    return event;
  }
  function syncSession(sessionId) {
    if (allowed()) cookie(sessionCookie, sessionId, 1800);
  }
  const context = document.querySelector('script[data-tk-posthog]')?.dataset || {};
  const storageKey = 'tk_ph_journey_v1';
  const qaKey = 'tk_ph_qa_v1';
  const viewId = crypto.randomUUID();
  let pdpRoot;
  let qaLabel = '';
  function storageRead(key) {
    try { return JSON.parse(window.sessionStorage.getItem(key) || 'null'); } catch { return null; }
  }
  function storageWrite(key, value) {
    try {
      if (value === null) window.sessionStorage.removeItem(key);
      else window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch {}
  }
  function pageProperties() {
    const theme = window.Shopify?.theme || {};
    const development = Boolean(theme.role && theme.role !== 'main');
    return {
      analytics_version: 'b13-v1',
      theme_id: String(theme.id || ''),
      theme_role: theme.role || 'unknown',
      template_suffix: context.templateSuffix || 'default',
      pdp_version: context.productId ? (pdpRoot?.dataset.analyticsVersion || context.templateSuffix || 'legacy') : '',
      traffic_type: development ? 'development' : qaLabel ? 'internal' : theme.role === 'main' ? 'production' : 'unknown',
      is_internal: development || Boolean(qaLabel),
      internal_qa: qaLabel,
      ...(window.TKFaceCreamAB?.properties?.() || {})
    };
  }
  function restoreQa() {
    const value = new URL(location.href || location.origin + location.pathname).searchParams.get('internal_qa');
    const saved = storageRead(qaKey);
    qaLabel = value === '0' ? '' : value && /^[a-zA-Z0-9_-]{1,80}$/.test(value) ? value :
      saved?.expires > Date.now() ? saved.label : '';
    window.tkFaceCreamInternalQa = Boolean(qaLabel);
    storageWrite(qaKey, qaLabel ? { label: qaLabel, expires: Date.now() + 30 * 60 * 1000 } : null);
  }
  let cartState = JSON.stringify({ ph_session_id: context.cartSession || '', ph_distinct_id: context.cartDistinct || '', ph_replay_url: context.cartReplay || '', ph_traffic_type: context.cartTraffic || '', ph_measurement_version: context.cartMeasurement || '' });
  let cartPending = false;
  let cartPromise = Promise.resolve(true);
  function cartAttributes() {
    const sdk = window.posthog;
    return allowed() && ready ? {
      ph_session_id: sdk.get_session_id(),
      ph_distinct_id: sdk.get_distinct_id(),
      ph_replay_url: safeUrl(sdk.get_session_replay_url()),
      ph_traffic_type: pageProperties().traffic_type,
      ph_measurement_version: 'b13-v1',
      ...(window.TKFaceCreamAB?.attributes?.() || {})
    } : { ph_session_id: '', ph_distinct_id: '', ph_replay_url: '', ph_traffic_type: '', ph_measurement_version: '', ...(window.TKFaceCreamAB?.attributes?.() || {}) };
  }
  function syncCart() {
    if (cartPending) return cartPromise;
    const next = JSON.stringify(cartAttributes());
    if (next === cartState) return Promise.resolve(true);
    cartPending = true;
    cartPromise = (async () => {
    let success = true;
    try {
      const response = await fetch((window.Shopify.routes?.root || '/') + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', keepalive: true,
        headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: JSON.parse(next) })
      });
      if (!response.ok) throw new Error('Cart attribution rejected');
      cartState = next;
    } catch {
      success = false;
      console.warn('Talitha Koum analytics could not update cart attribution.');
    } finally {
      cartPending = false;
      if (success && JSON.stringify(cartAttributes()) !== next) return syncCart();
    }
    return success;
    })();
    return cartPromise;
  }
  window.TKCartAttribution = { flush: syncCart };
  document.addEventListener('tk:ab-attribution', syncCart);
  let behaviorInstalled = false;
  let resetMeasurement = () => {};
  function installBehavior() {
    if (behaviorInstalled) return;
    behaviorInstalled = true;
    pdpRoot = document.querySelector('[data-tkfc]');
    const capture = (name, properties = {}, options) => {
      if (ready && allowed()) {
        window.posthog.capture(name, { ...properties, ...pageProperties() }, options);
        if (name === 'pdp_interaction' && ['gallery_change','reviews_open','details_open','video_play'].includes(properties.interaction)) window.TKFaceCreamAB?.track('exploration', { interaction: properties.interaction });
      }
    };
    const product = context.productId ? { product_id: context.productId, product_handle: context.productHandle, pdp_view_id: viewId } : {};
    const atcSelector = '[data-btn-addToCart], .csph__btn--cart, .tkp-card__btn--cart, .tk-subscribe-option, form[action$="/cart/add"] [name="add"]';
    const all = (selector) => [...(document.querySelectorAll?.(selector) || [])];
    const ctaLocation = (target) => {
      if (target?.closest?.('[data-pdp-pair]')) return 'pdp_recommendation';
      if (target?.closest?.('[data-tkfc-sticky], [data-csph-sticky]')) return 'sticky';
      if (target?.closest?.('.tkfc__close-purchase')) return 'closing';
      if (target?.matches?.('[data-tkfc-main-add]')) return 'hero';
      if (target?.closest?.('.tk-shop-all__card')) return 'collection';
      if (target?.closest?.('.tkp-card')) return 'home';
      return context.productId ? 'product_other' : 'other';
    };
    const sectionId = target => target?.closest?.('[data-tkfc-chapter]')?.dataset.tkfcChapter || 'hero';
    const numericId = value => /^\d+$/.test(String(value || '')) ? String(value) : undefined;
    const visible = node => {
      if (node.hidden || node.closest?.('[hidden]')) return false;
      const rect = node.getBoundingClientRect();
      const height = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
      const width = Math.max(0, Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0));
      return rect.height > 0 && width > 0 && height >= Math.min(96, rect.height * 0.5);
    };
    let visibleMs = 0;
    let activeMs = 0;
    let tickAt = Date.now();
    let checkedAt = -Infinity;
    let scrollDirty = false;
    let interactionAt = tickAt;
    let foreground = !document.hidden;
    let nextCheckpoint = 15000;
    let lastCheckpoint = -1;
    let engaged = false;
    const depths = new Set();
    const exposed = new Map();
    const sections = all('[data-tkfc-chapter]');
    const legacyAtc = document.querySelector('.csph__btn--cart') || document.querySelector('#product-add-to-cart');
    const ctas = pdpRoot ? [...pdpRoot.querySelectorAll(atcSelector)] : legacyAtc ? [legacyAtc] : [];
    const exposureTargets = [...sections, ...ctas];
    const galleryFrames = gallery => [...gallery.children].filter(node => node.matches('.tkfc__slide, .tkfc__research-frame'));
    const media = new Map(all('[data-tkfc-gallery] > [data-tkfc-media]').map(node => {
      const video = node.querySelector('video');
      return [node, {
        visible: false, since: null, sent: false, video, sample: null,
        watched: 0, ranges: [], milestones: new Set(),
        playback: video?.autoplay ? 'autoplay' : 'unknown',
        properties: { ...product, gallery: 'product', media_id: node.dataset.tkfcMedia,
          media_type: video ? 'video' : 'image', slide_index: galleryFrames(node.parentElement).indexOf(node) + 1 }
      }];
    }));
    const mediaObserver = media.size ? new window.IntersectionObserver(entries => {
      for (const entry of entries) {
        const state = media.get(entry.target);
        const inView = entry.isIntersecting && entry.intersectionRatio >= 0.5;
        if (state.visible !== inView) {
          state.visible = inView;
          state.since = null;
          state.sample = null;
        }
      }
    }, { threshold: [0, 0.5] }) : null;
    media.forEach((_state, node) => mediaObserver.observe(node));
    const resetMedia = () => media.forEach(state => { state.since = null; state.sample = null; });
    function watchVideo(state, now) {
      const video = state.video;
      const time = video.currentTime;
      const duration = video.duration;
      const previous = state.sample;
      state.sample = !video.paused && !video.ended && !video.seeking && video.readyState >= 2 ?
        { time, at: now, rate: video.playbackRate } : null;
      if (!previous || !state.sample || !Number.isFinite(duration) || duration <= 0) return;
      const elapsed = (now - previous.at) / 1000;
      const wrapped = time < previous.time && video.loop && previous.time > duration * 0.75 && time < duration * 0.25;
      const advance = wrapped ? duration - previous.time + time : time - previous.time;
      // Playback must advance at its expected rate; stalls, seeks and suspended timers do not count.
      if (elapsed <= 0 || elapsed > 2 || advance <= 0 || previous.rate <= 0 ||
          previous.rate !== state.sample.rate || advance > elapsed * previous.rate + 0.35) return;
      state.watched += Math.min(elapsed, advance / previous.rate);
      state.ranges.push(...(wrapped ? [[previous.time, duration], [0, time]] : [[previous.time, time]]));
      state.ranges.sort((a, b) => a[0] - b[0]);
      const merged = [];
      for (const range of state.ranges) {
        const last = merged.at(-1);
        if (last && range[0] <= last[1]) last[1] = Math.max(last[1], range[1]);
        else merged.push(range);
      }
      state.ranges = merged;
      const coverage = merged.reduce((seconds, range) => seconds + range[1] - range[0], 0) / duration;
      for (const milestone of ['3s', 'complete']) {
        if (state.milestones.has(milestone) || (milestone === '3s' ? state.watched < 3 : coverage < 0.95)) continue;
        capture('pdp_video_watch', {
          ...state.properties, milestone, playback: state.playback,
          watched_seconds: Math.round(state.watched * 100) / 100,
          duration_seconds: Math.round(duration * 100) / 100,
          coverage_percent: Math.min(100, Math.round(coverage * 100)),
          watch_definition: 'foreground_visible_half_media_playback_v1',
          ...(milestone === 'complete' ? { completion_definition: '95_percent_unique_video_timeline' } : {})
        });
        state.milestones.add(milestone);
      }
    }
    const counters = () => ({ visible_seconds: Math.round(visibleMs / 1000), active_seconds: Math.round(activeMs / 1000), active_idle_seconds: 30, duration_definition: 'foreground_recent_input_30s_v1' });
    function recentViews() {
      const saved = storageRead(storageKey);
      const session = window.posthog.get_session_id();
      if (!saved || saved.session !== session || !Array.isArray(saved.views)) return [];
      return saved.views.filter(view => view.at > Date.now() - 30 * 60 * 1000).slice(-20);
    }
    function rememberView() {
      if (!context.productId || !allowed()) return;
      const views = recentViews().filter(view => view.product_id !== context.productId);
      views.push({ ...product, pdp_version: pageProperties().pdp_version, traffic_type: pageProperties().traffic_type, at: Date.now(), ...counters() });
      storageWrite(storageKey, { session: window.posthog.get_session_id(), views: views.slice(-20) });
    }
    function checkpoint(reason, immediate = false) {
      if (!context.productId || !allowed() || lastCheckpoint === Math.floor(visibleMs)) return;
      lastCheckpoint = Math.floor(visibleMs);
      capture('pdp_dwell', { ...product, ...counters(), reason }, immediate ? { send_instantly: true, transport: 'sendBeacon' } : undefined);
      rememberView();
    }
    function tick(force = false) {
      const now = Date.now();
      // Bound layout reads during scrolling; lifecycle and purchase events flush immediately.
      if (!force && now - checkedAt < 250) return;
      checkedAt = now;
      const elapsed = Math.max(0, now - tickAt);
      const permitted = active && allowed();
      const modalOpen = permitted && Boolean(document.querySelector('dialog[open]'));
      const delta = elapsed <= 2000 && foreground && !modalOpen && permitted ? elapsed : 0;
      if (context.productId) {
        visibleMs += delta;
        activeMs += Math.min(delta, Math.max(0, interactionAt + 30000 - tickAt));
        if (!engaged && visibleMs >= 15000 && permitted) {
          engaged = true;
          capture('pdp_engaged', { ...product, via: 'visible_15s' });
        }
        for (const node of exposureTargets) {
          const state = exposed.get(node) || { since: null, sent: false };
          if (!state.sent) {
            if (!permitted || document.hidden || modalOpen || elapsed > 2000 || !visible(node)) state.since = null;
            else if (state.since === null) state.since = now;
            else if (now - state.since >= 1000) {
              const section = node.dataset.tkfcChapter;
              capture(section ? 'pdp_section_view' : 'atc_visible', {
                ...product, ...(section ? { section_id: section } : { cta_location: ctaLocation(node) }),
                exposure_definition: 'visible_96px_or_half_element_1s'
              });
              state.sent = true;
            }
            exposed.set(node, state);
          }
        }
        for (const [node, state] of media) {
          if (state.sent && (!state.video || state.milestones.size === 2)) continue;
          if (!permitted || !foreground || document.hidden || modalOpen || elapsed > 2000 || !state.visible) {
            state.since = null;
            state.sample = null;
            continue;
          }
          if (!state.sent) {
            if (state.since === null) state.since = now;
            else if (now - state.since >= 1000) {
              capture('pdp_media_view', { ...state.properties, exposure_definition: 'visible_half_media_1s' });
              state.sent = true;
            }
          }
          if (state.video && state.milestones.size < 2) watchVideo(state, now);
          if (state.sent && (!state.video || state.milestones.size === 2)) mediaObserver.unobserve(node);
        }
        if (visibleMs >= nextCheckpoint && now - interactionAt <= 30000) {
          checkpoint('interval');
          nextCheckpoint = visibleMs + 15000;
        }
        if (scrollDirty && permitted && (!document.hidden || (force && foreground))) {
          scrollDirty = false;
          const height = document.documentElement.scrollHeight - window.innerHeight;
          if (height > 0) {
            const percent = Math.min(100, Math.round(window.scrollY / height * 100));
            for (const depth of [25, 50, 75, 100]) if (percent >= depth && !depths.has(depth)) {
              depths.add(depth); capture('pdp_scroll', { ...product, depth });
            }
            if (!engaged && percent >= 50) {
              engaged = true; capture('pdp_engaged', { ...product, via: 'scroll_50' });
            }
          }
        }
      }
      tickAt = now;
    }
    resetMeasurement = () => {
      tickAt = Date.now(); interactionAt = 0; checkedAt = -Infinity; scrollDirty = false;
      exposed.forEach(state => { state.since = null; });
      resetMedia();
    };
    const activity = (force = false) => {
      tick(force);
      if (active && !document.hidden) interactionAt = Date.now();
    };
    if (context.productId) {
      capture('pdp_view', product);
      rememberView();
      setInterval(tick, 1000);
      for (const name of ['pointerdown', 'keydown', 'touchstart']) document.addEventListener(name, () => activity(true), { passive: true });
      window.addEventListener('scroll', () => {
        scrollDirty = true;
        activity();
      }, { passive: true });
      document.addEventListener('visibilitychange', () => {
        tick(true); foreground = !document.hidden;
        exposed.forEach(state => { state.since = null; });
        resetMedia();
        if (document.hidden) checkpoint('hidden', true);
        else interactionAt = Date.now();
      });
      window.addEventListener('pagehide', () => { tick(true); foreground = false; resetMedia(); checkpoint('pagehide', true); });
      window.addEventListener('pageshow', () => { tickAt = Date.now(); checkedAt = -Infinity; foreground = !document.hidden; resetMedia(); });
      for (const gallery of all('[data-tkfc-gallery], [data-tkfc-research]')) {
        let last = 0;
        let timer;
        gallery.addEventListener('scroll', () => {
          activity();
          clearTimeout(timer);
          timer = setTimeout(() => {
            const frames = galleryFrames(gallery);
            if (!frames.length) return;
            const first = frames[0]?.offsetLeft || 0;
            const limit = gallery.scrollWidth - gallery.clientWidth;
            const index = frames.reduce((best, frame, i) => Math.abs(Math.min(frame.offsetLeft - first, limit) - gallery.scrollLeft) < Math.abs(Math.min(frames[best].offsetLeft - first, limit) - gallery.scrollLeft) ? i : best, 0);
            if (index !== last && allowed() && !document.hidden) {
              capture('pdp_interaction', { ...product, interaction: 'gallery_change', section_id: sectionId(gallery), gallery: gallery.hasAttribute('data-tkfc-gallery') ? 'product' : 'research', slide_index: index + 1,
                ...(frames[index].dataset.tkfcMedia ? { media_id: frames[index].dataset.tkfcMedia } : {}) });
              last = index;
            }
          }, 180);
        }, { passive: true });
      }
      for (const details of all('[data-tkfc] details')) details.addEventListener('toggle', () => {
        if (!details.open) return;
        capture('pdp_interaction', { ...product, interaction: details.hasAttribute('data-tkfc-reviews') ? 'reviews_open' : 'details_open', section_id: sectionId(details), detail_index: all('[data-tkfc] details').indexOf(details) + 1 });
      });
      for (const video of all('[data-tkfc] video')) {
        const state = media.get(video.closest('[data-tkfc-media]'));
        let gestureAt = 0;
        video.addEventListener('pointerdown', () => { if (video.paused) gestureAt = Date.now(); }, { passive: true });
        video.addEventListener('keydown', event => { if ([' ', 'Enter'].includes(event.key) && video.paused) gestureAt = Date.now(); });
        video.addEventListener('play', () => {
          const userInitiated = gestureAt && Date.now() - gestureAt < 3000;
          if (userInitiated) capture('pdp_interaction', { ...product, interaction: 'video_play', section_id: sectionId(video), playback: 'user_initiated' });
          if (state) {
            state.playback = userInitiated ? 'user_initiated' : video.autoplay ? 'autoplay' : 'unknown';
            state.sample = null;
          }
          gestureAt = 0;
        });
        if (state) for (const name of ['pause', 'waiting', 'seeking', 'ratechange', 'emptied']) {
          video.addEventListener(name, () => { state.sample = null; });
        }
      }
    }
    let selectedVariant = pdpRoot?.querySelector?.('[data-tkfc-variant]')?.value;
    document.addEventListener('change', event => {
      const target = event.target;
      if (target.matches?.('[data-tkfc-variant], [data-tksoo-close-variant]') && target.value !== selectedVariant) {
        selectedVariant = target.value;
        capture('pdp_interaction', { ...product, interaction: 'variant_select', section_id: sectionId(target), variant_id: numericId(target.value) });
      }
      if (target.matches?.('[data-tkfc-sort]') && ['recent','high','low'].includes(target.value)) capture('pdp_interaction', { ...product, interaction: 'reviews_sort', section_id: 'reviews', sort: target.value });
    }, true);
    document.addEventListener('click', event => {
      const target = event.target.closest?.('a, button, input[type="submit"]');
      if (!target || target.disabled || target.getAttribute('aria-disabled') === 'true') return;
      if (target.matches(atcSelector)) {
        tick(true); checkpoint('cart_click');
        const form = target.form || target.closest('form');
        const variant = target.getAttribute('data-variant-id') || form?.querySelector('[name="id"]')?.value;
        capture('atc_click', { ...product, product_id: numericId(target.closest('[data-product-id]')?.dataset.productId) || context.productId,
          product_handle: target.closest('[data-product-handle]')?.dataset.productHandle || context.productHandle,
          variant_id: numericId(variant), quantity: Number(form?.querySelector('[name="quantity"]')?.value || 1), cta_location: ctaLocation(target) });
      }
      if (target.matches('[data-tkbr-btn]')) capture('pdp_interaction', { ...product, interaction: 'barrier_comparison', section_id: sectionId(target), comparison: ['weak','strong'].includes(target.dataset.tkbrBtn) ? target.dataset.tkbrBtn : 'unknown' });
      if (target.matches('[data-tkfc-more]')) capture('pdp_interaction', { ...product, interaction: 'reviews_more', section_id: 'reviews' });
      const href = target.getAttribute('href') || '';
      if (target.matches('[name="checkout"], button.btn-checkout, a.btn-checkout') || /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkout(?:[/?]|$)/i.test(href)) {
        tick(true); checkpoint('checkout'); capture('checkout_click'); syncCart();
      }
    }, true);
    function added(result, source, requestedQuantity) {
      if (!allowed()) return;
      tick(true); rememberView();
      for (const item of (result?.items || (result?.variant_id ? [result] : []))) {
        if (item.properties?._tk_launch_gift === 'launch-2026') continue;
        if (String(item.product_id) === '10272450838826' && Number(item.final_price ?? item.price) > 0) window.TKFaceCreamAB?.track('atc_succeeded', { product_id: String(item.product_id), variant_id: String(item.variant_id) });
        const view = recentViews().find(view => String(view.product_id) === String(item.product_id) && view.traffic_type === pageProperties().traffic_type);
        capture('add_to_cart', {
          product_id: item.product_id, variant_id: item.variant_id, product_handle: item.handle,
          line_quantity: item.quantity, price: (item.final_price ?? item.price) / 100, currency: context.currency,
          added_quantity: Number.isInteger(requestedQuantity) && requestedQuantity > 0 ? requestedQuantity : undefined,
          cta_location: source ? ctaLocation(source) : 'unknown',
          source_pdp_view_id: view?.pdp_view_id, source_pdp_version: view?.pdp_version,
          source_pdp_active_seconds: view?.active_seconds, source_pdp_visible_seconds: view?.visible_seconds,
          after_pdp: Boolean(view), via_catalog: Boolean(view && !context.productId)
        });
      }
      syncCart();
    }
    document.addEventListener('tk:cart-add-failed', event => { if (String(event.detail?.variant_id) === '52340097581354') window.TKFaceCreamAB?.track('atc_failed'); });
    document.addEventListener('tk:cart-added', event => added(event.detail, event.detail?._tk_submitter, event.detail?._tk_quantity));
    document.addEventListener('tk:gift-updated', event => { if (allowed()) capture('launch_gift_added', event.detail); });
    if (window.jQuery) window.jQuery(document).on('ajaxSuccess.tkPostHog', (_event, xhr, settings, data) => {
      if (!allowed()) return;
      let url;
      try { url = new URL(settings.url, location.origin); } catch { return; }
      if (url.origin === location.origin && /\/cart\/add\.js$/.test(url.pathname)) added(data || xhr.responseJSON);
    });
  }
  function syncConsent() {
    if (!allowed()) {
      if (ready) window.posthog.opt_out_capturing();
      cookie(idCookie, '', 0);
      cookie(sessionCookie, '', 0);
      active = false;
      qaLabel = '';
      storageWrite(storageKey, null);
      storageWrite(qaKey, null);
      resetMeasurement();
      syncCart();
      return;
    }
    if (ready) {
      if (!active) {
        restoreQa();
        pdpRoot = document.querySelector('[data-tkfc]');
        resetMeasurement();
        window.posthog.opt_in_capturing({ captureEventName: false });
        cookie(idCookie, window.posthog.get_distinct_id());
        syncSession(window.posthog.get_session_id());
        window.posthog.capture('$pageview');
        active = true;
        installBehavior();
        window.TKFaceCreamAB?.analyticsReady();
        syncCart();
      }
      return;
    }
    if (loading) return;
    loading = true;
    const id = readCookie(idCookie) || crypto.randomUUID();
    cookie(idCookie, id);
    const script = document.createElement('script');
    script.src = 'https://us-assets.i.posthog.com/static/array.js';
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.onerror = () => {
      loading = false;
      console.warn('Talitha Koum analytics SDK could not load.');
    };
    script.onload = () => {
      if (!allowed()) { loading = false; return; }
      if (!window.posthog?.init) {
        loading = false;
        console.warn('Talitha Koum analytics SDK is unavailable.');
        return;
      }
      window.posthog.init(token, {
        api_host: 'https://us.i.posthog.com',
        ui_host: 'https://us.posthog.com',
        defaults: '2026-05-30',
        bootstrap: { distinctID: readCookie(idCookie) || id, isIdentifiedID: false },
        persistence: 'cookie',
        cross_subdomain_cookie: false,
        secure_cookie: true,
        person_profiles: 'never',
        capture_pageview: false,
        capture_pageleave: true,
        autocapture: { dom_event_allowlist: ['click'], element_allowlist: ['a', 'button'] },
        mask_all_text: true,
        mask_all_element_attributes: true,
        capture_exceptions: false,
        disable_session_recording: false,
        capture_performance: { web_vitals: true, network_timing: false },
        disable_surveys: true,
        enable_recording_console_log: false,
        session_recording: {
          maskAllInputs: true,
          maskTextSelector: '*',
          blockSelector: 'iframe, .ph-no-capture, [data-posthog-block], a[href^="mailto:"], a[href^="tel:"]',
          recordCrossOriginIframes: false,
          maskCapturedNetworkRequestFn: () => undefined
        },
        before_send: scrub,
        loaded: (sdk) => {
          ready = true;
          loading = false;
          sdk.register({ store: 'talithakoum.com', integration: 'tk-shopify-v1' });
          sdk.onSessionId((sessionId) => { syncSession(sessionId); syncCart(); if (active) window.TKFaceCreamAB?.analyticsReady(); });
          syncConsent();
        }
      });
    };
    document.head.appendChild(script);
  }
  document.addEventListener('visitorConsentCollected', syncConsent);
  function initialize() {
    if (window.Shopify?.customerPrivacy) return syncConsent();
    if (!window.Shopify?.loadFeatures) {
      console.warn('Talitha Koum analytics is waiting for the Shopify privacy API.');
      return;
    }
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (error) console.warn('Talitha Koum analytics could not read consent.');
      else syncConsent();
    });
  }
  const start = () => window.TKFaceCreamAB ? window.TKFaceCreamAB.ready.then(initialize) : initialize();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
